import { AuthState } from "../../core/models/auth";

export const initialState: AuthState = {
    authResponse: null,
    user: null,
    firebaseResponse: null
};